export enum Event {
    INTERNAL = "INTERNAL",
    EXTERNAL = "EXTERNAL"
}
